"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfflineClient = exports.OfflineAction = exports.OfflineClient = void 0;
const debug_1 = __importDefault(require("debug"));
const apollo_offline_1 = __importStar(require("@wellth/apollo-offline"));
exports.OfflineClient = apollo_offline_1.default;
Object.defineProperty(exports, "OfflineAction", {
  enumerable: true,
  get: function () {
    return apollo_offline_1.OfflineAction;
  }
});
const offline_1 = __importDefault(require("./links/offline"));
const online_1 = require("./links/online");
const createOfflineClient = _a => {
  var resolvers = _a.resolvers,
    _a$disableOffline = _a.disableOffline,
    disableOffline = _a$disableOffline === void 0 ? false : _a$disableOffline,
    _a$connectToDevTools = _a.connectToDevTools,
    connectToDevTools = _a$connectToDevTools === void 0 ? false : _a$connectToDevTools,
    offlineLink = _a.offlineLink,
    networkLink = _a.networkLink,
    error = _a.error,
    enableLogging = _a.enableLogging,
    log = _a.log,
    debugLogEnabled = _a.debugLogEnabled,
    cacheOptions = _a.cacheOptions,
    storage = _a.storage,
    typeDefs = _a.typeDefs,
    name = _a.name,
    mutationCacheUpdates = _a.mutationCacheUpdates,
    callback = _a.callback,
    _a$discardCondition = _a.discardCondition,
    discardCondition = _a$discardCondition === void 0 ? () => false : _a$discardCondition,
    onlineOptions = __rest(_a, ["resolvers", "disableOffline", "connectToDevTools", "offlineLink", "networkLink", "error", "enableLogging", "log", "debugLogEnabled", "cacheOptions", "storage", "typeDefs", "name", "mutationCacheUpdates", "callback", "discardCondition"]);
  if (debugLogEnabled) {
    debug_1.default.enable("apollo-offline*");
  }
  if (log) {
    debug_1.default.log = log;
  }
  return new apollo_offline_1.default({
    cacheOptions,
    disableOffline,
    mutationCacheUpdates,
    offlineLink: (0, offline_1.default)({
      error,
      enableLogging
    }, offlineLink),
    onlineLink: (0, online_1.OnlineLink)(networkLink, onlineOptions),
    offlineConfig: {
      storage,
      callback,
      discardCondition
    }
  }, {
    resolvers,
    typeDefs,
    name,
    connectToDevTools
  });
};
exports.createOfflineClient = createOfflineClient;
exports.default = exports.createOfflineClient;